import { error } from "@sveltejs/kit";
import client from "$lib/gql/apolloClient";
import { GetNavDoc, GetResourceByUrlDoc } from "$lib/gql/genCms/codegen";
import type {
  GetNavQuery,
  GetResourceByUrlQuery,
} from "$lib/gql/genCms/codegen";
import { Errors } from "$lib/data/errors.data";

/** @type {import('./$types').PageLoad} */
export async function load({ params, parent }) {
  const { landing } = params;
  const parentData = await parent();

  try {
    const pageQuery = await client.query<GetResourceByUrlQuery>({
      query: GetResourceByUrlDoc,
      variables: {
        url: landing,
        limit: 100,
      },
      context: {
        clientName: "cms",
        clientIP: parentData.session?.clientIP,
        preview: parentData?.preview,
      },
      errorPolicy: "ignore", // allows page not found errors to be handled below
    });

    if (landing === "sale" && !pageQuery.data?.ResourceByURL) {
      const fallbackQuery = await client.query<GetResourceByUrlQuery>({
        query: GetResourceByUrlDoc,
        variables: {
          url: "men",
          limit: 100,
        },
        context: {
          clientName: "cms",
          clientIP: parentData.session?.clientIP,
          preview: parentData?.preview,
        },
        errorPolicy: "ignore", // allows page not found errors to be handled below
      });

      const navQuery = await client.query<GetNavQuery>({
        query: GetNavDoc,
        variables: {
          id: "main",
        },
        context: {
          clientName: "cms",
          clientIP: parentData.session?.clientIP,
          preview: parentData?.preview,
        },
      });

      if (navQuery.data?.Nav && fallbackQuery.data?.ResourceByURL) {
        const emptyBanner = navQuery?.data?.Nav?.items?.find(
          item => item.title === "New Arrivals",
        );
        return {
          landing: landing,
          data: { ...fallbackQuery, navData: navQuery },
          emptyBanner,
        };
      }
    }

    if (!pageQuery.data?.ResourceByURL) {
      throw error(404, Errors.NotFound);
    }

    return {
      landing: landing,
      data: pageQuery,
    };
  } catch (err: any) {
    throw error(404, {
      message: err && err.message ? err.message : Errors.NotFound,
    });
  }
}
